import { cn } from '@/lib/utils'

const PLAN_LABELS: Record<string, string> = {
  starter: 'Starter',
  builder: 'Scale',
}

export function PlanBadge({ plan, className }: { plan: string; className?: string }) {
  const isBuilder = plan === 'builder'
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider',
        isBuilder
          ? 'bg-purple-500/15 text-purple-300 border border-purple-500/20'
          : 'bg-slate-500/15 text-slate-300 border border-slate-500/20',
        className
      )}
    >
      {PLAN_LABELS[plan] ?? plan}
    </span>
  )
}
